import FormData from "csi/action/FormData";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";


const PushCareLabelsWizard = declare([Controller, ActionControllerMixin], {
	onNextPage: function(
		/*csi.wizard.Widget*/wizard,
		/*csi.wizard.Content*/currentPage,
		/*csi.wizard.Content*/nextPage,
		/*Boolean*/bFinish,
	) {
		// summary: prepare the data and pass it into the next page
		this.m_formData.setNode(null);
		return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
	},

	getFormData: function() {
		const	fd = this.inherited(arguments) as any;
		fd.m_bRequireOne = true;
		return fd;
	},

	process: function() {
		// summary: issue request so as to be able to receive return value
		const request = this.m_action.m_request;

		this.setProgress();

		const cnls = this.m_formData.getSelectedValue();
		const careSymbols = [];
		const apparelBOMs = [];
		cnls.forEach((cnl) => {
			const node = this.m_cache.getNode(cnl);
			if (node.$Type === "CareSymbol") {
				careSymbols.push(cnl);
			} else {
				apparelBOMs.push(cnl);
			}
		});

		new PostRequest(request.m_module, request.m_operation)
			.addParameter("CareSymbols", careSymbols)
			.addParameter("ApparelBOMs", apparelBOMs)
			.post({})
			.then(lang.hitch(this, this._onPublishResponse));
	},
});

export = PushCareLabelsWizard;